<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <el-col :span="22" :offset="1"  class="page-title">Cache Manager</el-col>
      <el-col :span="22" :offset="1">
        <el-button type="danger" @click="clean()">Delete Dictionary Cache</el-button>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import { dictionaryCacheClean } from '@/services/dictionary.service'
import Footer from '@/components/Footer.vue'
import Constant from '@/common/Constant'
import { verifyUserInfo } from '@/services/login.service'

export default {
  components: {
    Footer
  },
  data () {
    return {
      userType: ''
    }
  },
  methods: {
    clean () {
      this.$confirm(Constant.MESSAGE_CONFIRM_DELETE_CACHE, Constant.MESSAGE_CONFIRM_WARNING_TITLE, {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Discard Delete'
      })
        .then(() => {
          this.cleanDictionary();
        });
    },
    async cleanDictionary () {
      await dictionaryCacheClean().then(() => {
        this.$message({
          type: 'success',
          message: 'Cache delete success.'
        });
      });
    },
    async verifyUser () {
      let user = await verifyUserInfo();

      this.userType = user.role;
    }
  },
  created () {
    this.verifyUser();
  }
}
</script>

<style scoped>
  .page-title{
    font-size: 20px;
    margin-top: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/manager/ServerCacheManager.vue